import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EWalletMutationSortField,
  IWalletMutation,
  PWalletMutationFilter,
} from "src/core/walletMutation/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IWalletMutationState {
  walletMutations: IWalletMutation[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IWalletMutationState = {
  walletMutations: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "wallet-mutation/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "wallet-mutation/FETCH_SUCCEEDED";
const FETCH_FAILED = "wallet-mutation/FETCH_FAILED";
const POLLING_START_REQUESTED = "wallet-mutation/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "wallet-mutation/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IWalletMutation[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    userId: number;
    filter: PWalletMutationFilter;
    pagination: IPagination;
    sorts: ISort<EWalletMutationSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IWalletMutationState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IWalletMutationState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.walletMutations = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
